import React, { useState } from 'react'
import Select from 'react-select'
import { Checkbox, Drawer } from 'antd'

import { usePet, useToggle, useListData } from '../../modules'
import { accountTypes } from '../../data'
import SelectLabel from '../reusable/selectLabel'

const PaymentMethod = ({ method, toggle, visible, onPerform }) => {
    const [accounts, setAccounts] = useState([])
    const [name, setName] = useState(method?.name)
    const [account, setAccount] = useState({ label: method?.account?.name, value: method?.account?._id })

    const close = () => {
        toggle()
    }
    
    const [
        { loading: accLoading, fetch }, , 
        { navigate }
    ] = useListData('accounts', { types: ['Cash', 'Bank'] }, { notify: true, manual: false }, 'accounts', 100, ({ accounts: data }) => {
        let obj = {}
        
        data.forEach(acc => {
            if (!obj[acc.type])
                obj[acc.type] = []

            obj[acc.type].push({
                label: acc.name,
                value: acc._id
            })
        })

        let final = []
        for (let typ in obj) {
            final.push({
                label: typ,
                options: obj[typ]
            })
        }

        setAccounts(final)
    })

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif('Payment method has been added', ops('success'))
        
        setTimeout(close, 300)
    }

    const [{ loading }, execute] = usePet('editPaymentMethod', {
        id: method?._id,
        name,
        account: account?.value
    }, { notify: true, callback: onComplete, manual: true })

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button disabled={ loading } onClick={execute} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save Changes</button>
                </div>
            }
            width="30%">
            <p className="font-extrabold text-3xl mb-0">Edit Payment Method</p>
            <div className="flex flex-wrap mt-3">
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Method Name
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-name"
                        name="name"
                        value={name}
                        onChange={ e => setName(e.target.value) }
                        type="text"
                        placeholder="Account Name" />
                </div>
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                        Account
                    </label>
                    <Select
                        className="mb-3"
                        value={account}
                        onChange={setAccount}
                        formatGroupLabel={SelectLabel}
                        options={ accounts }
                        placeholder="Select account" />
                </div>
            </div>
        </Drawer>
    )
}

export default PaymentMethod